// Personalized Interval handlers for setting and clearing Interval Timers
// Goal is to track the Intervals and Timeouts in play.  This allows you to
//  kill all Intervals and Timeouts in one call, if the user has been logged
//  out or lost connection with the server.
//
// Created by: Josh Burnell, 9/28/10

goog.provide('el8.service.intervals');

(function($) {
    
    var intervalIds = [];
    
    $.el8_setInterval = function (fn, interval) {
        var id = setInterval(fn, interval);
        intervalIds.push(id);
        return id;
    };
    
    $.el8_clearInterval = function (intervalId) {
        var idx = intervalIds.indexOf(intervalId); // Find the index
        if (idx!=-1) intervalIds.splice(idx, 1); // Remove it if really found!
        clearInterval(intervalId);
    };
    
    $.el8_clearAllIntervals = function () {
        for (var i=0; i<intervalIds.length; i++) {
            clearInterval(intervalIds[i]);
        };
    };
    
    $.el8_setTimeout = function (fn, interval) {
        var id = setTimeout(fn, interval);
        intervalIds.push(id);
        return id;
    };
    
    $.el8_clearTimeout = function (intervalId) {
        var idx = intervalIds.indexOf(intervalId); // Find the index
        if (idx!=-1) intervalIds.splice(idx, 1); // Remove it if really found!
        clearTimeout(intervalId);
    };
    
})(jQuery);
